import React from 'react';
import './Message.css';
import mdImage from '../../assets/images/haji.jpg'; // replace with your actual image path

const Message = () => {
  return (
    <section className="md-section">
      <div className="md-container">
        
        {/* Left: Image */}
        <div className="md-image">
          <img src={mdImage} alt="Managing Director" />
        </div>

        {/* Right: Text */}
        <div className="md-text">
          <h3>Managing Director’s Message</h3>
          <h2>A Vision of Education and Excellence</h2>
          <p>
            Welcome to Alasar Academy, where our mission is to provide students
            with the knowledge, confidence, and discipline to excel in life. 
            We believe education is not just about academics—it’s about building 
            character, fostering curiosity, and inspiring lifelong learning.
          </p>
          <p>
            Our academy stands as a beacon of commitment to quality education 
            and community development. Together, we aim to empower young minds 
            to contribute positively to society and the world beyond.
          </p>

          <div className="md-signature">
            <h4>— Mr.Haji Ahmed Raza</h4>
            <p>Managing Director, Alasar Academy</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Message;
